import React from 'react';

function Interests() {
  return (
    <div className='education resume-main-content'>
        <div className='resume-heading'>
            <div className='main-heading'>
                <div className='bullet'></div>
                <span className='interest-title main-heading-content'>Building Web Applications</span>
            </div>
            <div className='sub-heading'>
                <div className='sub-heading-details interest-description'>
                    I spend my free time to improve my web application building skills and also I work on hobby web applications. 
                </div>
            </div>
        </div>

        <div className='resume-heading'>
            <div className='main-heading'>
                <div className='bullet'></div>
                <span className='interest-title main-heading-content'> Listening Music</span>
            </div>
            <div className='sub-heading'>
                <div className='sub-heading-details interest-description'>
                    Listening to music is what I love when i'm free or when working on things which are repetative in nature.  
                </div>
            </div>
        </div>
        
    </div>
    )
}

export default Interests;